module.exports = __webpack_public_path__ + "static/media/fotorrhh1.728e6b3f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rrhh/fotorrhh1.webp
// module id = 1013
// module chunks = 0